"use client";
import { Badge as PrismaBadge } from "@prisma/client";
import Image from "next/image";
import { useBreakpointV3 } from "~/hooks/useIsMobile";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
    useTooltip,
} from "../shadcn/Tooltip";

const BadgeImage = ({
    badge,
    size,
}: {
    badge?: Partial<PrismaBadge> & { count?: number };
    size: number;
}) => {
    return (
        <Image
            key={badge?.id}
            alt={`badge-${badge?.name}`}
            width={size}
            height={size}
            src={`${badge?.path ?? ""}`}
        />
    );
};

const Badge = ({
    badge,
    size = 50,
}: {
    badge?: Partial<PrismaBadge> & { count?: number };
    size?: number;
}) => {
    const { showTooltip, handleTooltipClick } = useTooltip();
    const isDesktop = useBreakpointV3("md");
    const tooltipInfo =
        badge?.description !== "" ? badge?.description : badge?.name;

    return (
        <div className="relative">
            <TooltipProvider delayDuration={0}>
                {!isDesktop ? (
                    <Tooltip open={showTooltip}>
                        <TooltipTrigger onClick={handleTooltipClick}>
                            <BadgeImage badge={badge} size={size} />
                        </TooltipTrigger>
                        <TooltipContent sideOffset={-100}>
                            <p className="text-[12px]">{tooltipInfo}</p>
                        </TooltipContent>
                    </Tooltip>
                ) : (
                    <Tooltip>
                        <TooltipTrigger>
                            <BadgeImage badge={badge} size={size} />
                        </TooltipTrigger>

                        <TooltipContent sideOffset={-100}>
                            <p className="text-[12px]">{tooltipInfo}</p>
                        </TooltipContent>
                    </Tooltip>
                )}
            </TooltipProvider>
            {badge?.count && badge?.count > 1 && (
                <span className="absolute -bottom-1 left-[15px] flex h-[15px] w-[20px] items-center justify-center rounded-md bg-green-600 text-[11px] font-bold leading-none text-black">
                    {badge.count}
                </span>
            )}
        </div>
    );
};

const DeletableBadge = ({
    badge,
    onDelete,
}: {
    badge?: Partial<PrismaBadge> & { count?: number };
    onDelete: () => void;
}) => {
    return (
        <div>
            <Badge badge={badge} />
        </div>
    );
};

export default Badge;
